import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }
`;
const MapContainer = styled.div `
  position: relative;
  height: 300px;
  margin: 0 0 ${fluid(20, 40)};
  grid-column: 1 / span 6;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 8;
  }
`;
const MapInner = styled.div `
  height: 100%;
  width: calc(100% + (var(--sitePadding) * 2));
  margin-left: calc(var(--sitePadding) * -1);

  @media ${from(Device.TabletLarge)} {
    width: 100%;
    height: 100%;
    margin: 0;
  }
`;
const CardsContainer = styled.div `
  display: flex;
  grid-gap: var(--gutterWidth);
  flex-wrap: wrap;
  grid-column: 1 / span 6;

  @media ${from(Device.Tablet)} {
    grid-column: 1 / span 8;
    flex-wrap: nowrap;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 3 / span 8;
  }
`;
const Card = styled.div `
  width: 100%;

  @media ${from(Device.Tablet)} {
    width: 50%;
  }
`;
const BranchDetailsStyles = {
    Container,
    MapContainer,
    MapInner,
    CardsContainer,
    Card,
};
export default BranchDetailsStyles;
